// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2ZYCt","left":"StickyBox_left__aL1Zc","right":"StickyBox_right__1ehFf"};